import styled from "styled-components";
import { FlexDiv } from "@/components/Atoms/Box";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";

import Modal from "@/components/Molecules/Modal";
import { TwoColumnModal } from "@/components/Organisms/TwoColumnSection";
import Typography from "@/foundation/Typography/V2";

export const StyledModal = styled(Modal)`
  padding: 0;
  .body-wrapper {
    padding: 0;
  }
`;

export const CloseText = styled(Typography)`
  display: flex;
  align-items: center;
  top: 32px;
  left: 8px;
  position: absolute;
  @media only screen and (max-width: 1079px) {
    top: 24px;
    left: 32px;
  }
`;
export const InnerColumn = styled(FlexDiv)`
  padding: 32px 32px 32px 8px;
  position: relative;
  justify-content: center;
  @media only screen and (max-width: 1079px) {
    padding: 24px 32px;
  }
`;
export const Title = styled(Typography)`
  margin: 56px 0 40px;
  color: ${({ theme }) => theme.colors.white};
  @media only screen and (max-width: 1079px) {
    margin: 40px 0 24px;
  }
`;

export const StyledTwoColumnModal = styled(TwoColumnModal)`
  background-color: transparent;
  padding: 24px;
  border: none;
  @media only screen and (max-width: 1079px) {
    border-radius: 24px 24px 0 0;
    padding: 0;
    max-height: calc(100vh - 80px);
    overflow: hidden auto;
  }
  .left-section {
    padding: 0;
    flex: 1;
    ${CloseText} {
      cursor: pointer;
    }
    @media only screen and (max-width: 1079px) {
      max-width: 100%;
    }
  }
  .right-section {
    max-width: 408px;
    width: 100%;
    padding: 0;
    > div {
      border: 0;
    }
    @media only screen and (max-width: 1079px) {
      max-width: 100%;
      > div {
        border-radius: 24px 24px 0 0;
      }
    }
  }
`;

export const CloseIcon = styled(StyledSvgSprite)`
  margin-right: 4px;
`;
